import { elements } from '@ecosystem/newron-design-system';
import React from 'react';
import { FilterAction } from './FilterAction';
import { ButtonProps } from './types';

const { Icon } = elements;

export function ApplyAction(props: ButtonProps & { applied?: boolean }) {
  const { applied, disabled, testId, getTrackingTags, onClick } = props;
  const className = `px-${applied ? 0 : 1}`;

  return (
    <FilterAction
      className={className}
      disabled={applied || disabled}
      label={applied ? 'Applied' : 'Apply'}
      testId={testId}
      getTrackingTags={getTrackingTags}
      onClick={onClick}
    >
      <Icon.icons.Check />
    </FilterAction>
  );
}
